import React, { useEffect, useState } from "react";
import { CustomeStyle } from "../Css/CustomeStyle";
import AllProduct from "./AllProduct";
import { FaRegHeart, FaHeart } from "react-icons/fa";
import Header from "./header";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Footer from "../Fotter";
import {
  FaShoppingCart,
  FaCreditCard,
  FaArrowCircleRight,
} from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { AddToCart } from "../redux/slices/AddTocartSlice";
import { viewCartData } from "../redux/slices/ViewCartSlice";
import { RelatedProduct } from "../redux/slices/RelatedProductSlice";
import { toast } from "react-toastify";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import { FaStar, FaRegStar } from "react-icons/fa";
import { GetReview } from "../redux/slices/GetReviewSlice";
import { ProductById } from "../redux/slices/ProductByIdSlice";
import { AddReview } from "../redux/slices/AddReviewSlice";
import { AddWishlist } from "../redux/slices/AddWishlistSlice";
import { AiOutlineArrowLeft } from "react-icons/ai";
import image1 from "../assets/showDetail.png";
import { GetCategory } from "../redux/slices/GetCategorySlice";
import LoaderPage from "./Loader";
import AmbitionBox from "../assets/Rating4.png"
import Scamadviser from "../assets/Rating3.png"
import Glassdoor from "../assets/Rating2.png"

const ProductDetails = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const page = location?.state?.page;
  const item =
    location.state?.item || location?.state?.productId || location?.state?.name;
  const { ViewCart } = useSelector((state) => state.viewCart);
  const [isInCart, setIsInCart] = useState(false);
  const { RelatedProductData } = useSelector((state) => state?.relatedProduct);
  const [images, setImages] = useState("");
  const [likedProducts, setLikedProducts] = useState(new Set());
  const { ProductDetailsData } = useSelector((state) => state?.productById);
  const { GetReviewData } = useSelector((state) => state?.getReviewData);
  const [showModal, setShowModal] = useState(false);
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(null);
  const [review, setReview] = useState("");
  const [userName, setUserName] = useState("");
  const { title } = useParams();
  const [loader, setLoader] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const { AllCategory } = useSelector((state) => state.category);
  const [subCategory, setSubCategory] = useState("");
  const [showAll, setShowAll] = useState(false);
  const [categoryId, setCategoryId] = useState("");
  const [userEmail, setUserEmail] = useState('')
  const [showModalQuantity, setModalQuantity] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const [selectedBulkIndex, setSelectedBulkIndex] = useState(null);

  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  const _handleReview = (rate) => {
    setRating(rate);
    setShowModal(true);
  };

  useEffect(() => {
    dispatch(GetCategory());
  }, [dispatch]);

  useEffect(() => {
    const category = AllCategory?.find(
      (category) => category.name === ProductDetailsData?.product?.category
    );
    setCategoryId(category?._id);
    setSubCategory(category?.subcategories);
  }, [ProductDetailsData?.product]);

  useEffect(() => {
    setLoader(true);
    const fetchData = async () => {
      try {
        if (title) {
          const response = await dispatch(ProductById(title));
          const productData = response?.payload?.product;
          const productId = productData?._id;
          if (productId) {
            await dispatch(viewCartData());
            await dispatch(RelatedProduct(productId));
            await dispatch(GetReview(productId));
          }
        }
      } catch (error) {
        console.error("Error fetching product-related data:", error);
      } finally {
        setLoader(false);
      }
    };
    fetchData();
  }, [dispatch, item, title]);

  useEffect(() => {
    showAddCart();
  }, [ViewCart, isInCart]);

  useEffect(() => {
    if (!selectedBulkIndex) return;
    const cartData = {
      productId: ProductDetailsData?.product?._id,
      quantity: selectedBulkIndex?.end,
    };
    dispatch(AddToCart(cartData)).then((result) => {
      setLoader(false);
      if (result.meta.requestStatus === "fulfilled") {
        dispatch(viewCartData());
        toast.success("Product added to cart!", {
          position: "top-right",
          autoClose: 2000,
          style: {
            backgroundColor: "#d0d3d4 ",
            color: "black",
            fontWeight: "bold",
          },
        });
        setModalQuantity(false)
      } else {
        setLoader(false);
      }
    });
  }, [!selectedBulkIndex])

  const showAddCart = () => {
    if (Array.isArray(ViewCart?.cart)) {
      const cartExists = ViewCart?.cart.some(
        (cartItem) => cartItem?.productId === ProductDetailsData?.product?._id
      );
      if (isInCart !== cartExists) {
        setIsInCart(cartExists);
      }
    } else {
    }
  };

  const toggleLike = (productId) => {
    dispatch(AddWishlist(productId));
    setLikedProducts((prevLikedProducts) => {
      const updatedLikes = new Set(prevLikedProducts);
      if (updatedLikes.has(productId)) {
        updatedLikes.delete(productId);
      } else {
        updatedLikes.add(productId);
      }
      return updatedLikes;
    });
  };

  const handleAddToCart = () => {
    setLoader(true);
    const cartData = {
      productId: ProductDetailsData?.product?._id,
      quantity: quantity,
    };
    dispatch(AddToCart(cartData)).then((result) => {
      setLoader(false);
      if (result.meta.requestStatus === "fulfilled") {
        dispatch(viewCartData());
        toast.success("Product added to cart!", {
          position: "top-right",
          autoClose: 2000,
          style: {
            backgroundColor: "#d0d3d4 ",
            color: "black",
            fontWeight: "bold",
          },
        });
        setModalQuantity(false)
      } else {
        setLoader(false);
      }
    });
  };

  const handleAddToCartBuy = () => {
    const cartData = {
      productId: ProductDetailsData?.product?._id,
      quantity: 1,
    };
    dispatch(AddToCart(cartData)).then((result) => {
      if (result.meta.requestStatus === "fulfilled") {
        dispatch(viewCartData());
        navigate("/cart");
      } else {
        console.log("Responce Error");
      }
    });
  };

  const handleSubmit = () => {
    if (!userName || !userEmail || !review || rating === 0) {
      alert("Please fill out all fields and provide a rating before submitting.");
      return;
    }
    const reviewData = {
      productId: ProductDetailsData?.product?._id,
      rating: rating,
      comment: review,
      name: userName,
      email: userEmail
    };
    dispatch(AddReview(reviewData)).then((result) => {
      if (result.meta.requestStatus === "fulfilled") {
        dispatch(GetReview(ProductDetailsData?.product?._id));
        setShowModal(false);
        setRating(0);
        setReview("");
        setUserName("");
      } else {
      }
    });
  };

  const handleBack = () => {
    if (page) {
      navigate("/AllProductData", {
        state: {
          page,
        },
      });
    } else {
      navigate(-1);
    }
  };

  const description = ProductDetailsData?.product?.description || "";
  const descriptionPoints = description
    ?.split(/-\s*(?=[A-Z])/)
    .map((line) =>
      line
        .trim()
        .replace(/^\s*-\s*/, "")
        .replace(/\.$/, "")
    )
    .filter((line) => line !== "");

  const _handleClick = (name) => {
    navigate(`/product-category/${name.category}/${name._id}`, {
      state: { name },
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const visibleItems = showAll ? subCategory : subCategory?.slice(0, 6);

  const _handleSubCategoryClick = (subcategory) => {
    localStorage.setItem("SubCategoryName", subcategory?.name);
    navigate(
      `/ShowSubCategory/${ProductDetailsData?.product?.category}/${subcategory?.name}/${categoryId}`,
      {
        state: {
          name: ProductDetailsData?.product?.category,
          SubCategoryName: subcategory?.name,
        },
      }
    );
  };

  return (
    <div className=" text-black ">
      <Header />
      <div className="flex flex-col min-h-screen">
        <div className="flex-grow">
          {loader ? (
            <div className="text-center font-semibold text-lg py-10 m-5 ">
              Loading...
            </div>
          ) : ProductDetailsData && Object.keys(ProductDetailsData).length > 0 ? (
            <>
              <div className="flex flex-col min-h-screen">
                <div className="flex-grow">
                  <>
                    <div className="mx-auto flex items-center w-[90%] mt-5 justify-between">
                      <button
                        onClick={handleBack}
                        className="mr-2 bg-gray-200 px-2 py-2 rounded-full flex items-center"
                      >
                        <AiOutlineArrowLeft className="text-lg mr-1" />
                      </button>
                      <h1 className="sm:text-4xl text-xl font-bold text-center text-gray-600">
                        Product Details
                      </h1>
                      <h1></h1>
                    </div>

                    <div className="flex flex-col md:flex-row  mt-4 md:mt-8 sm:mt-10 w-[90%] mx-auto justify-center">
                      <div className="w-full md:w-1/2 flex justify-center mb-10">
                        <div className="sticky top-24 max-h-[calc(100vh-100px)]  ">
                          <div className="relative flex justify-center   w-[90%]  ">
                            <Zoom>
                              <img
                                loading="lazy"
                                src={
                                  images
                                    ? images
                                    : ProductDetailsData?.product?.productimage1
                                      ? ProductDetailsData?.product?.productimage1
                                      : ProductDetailsData?.product?.images
                                        ?.productimage1
                                }
                                alt={
                                  ProductDetailsData?.product?.images?.productimage1
                                }
                                className="h-96 border p-4 border-gray-300 sm:mt-0 mt-4 sm:w-full sm:ml-0 ml-5"
                              />
                            </Zoom>
                            <button
                              className="like-btn absolute sm:top-2 top-6 right-6 sm:right-3"
                              onClick={() =>
                                toggleLike(ProductDetailsData?.product?._id)
                              }
                            >
                              {likedProducts.has(ProductDetailsData?.product?._id) ? (
                                <FaHeart size="24px" color="red" />
                              ) : (
                                <FaRegHeart size="24px" color="pink" />
                              )}
                            </button>
                          </div>

                          {ProductDetailsData?.product?.images && (
                            <div className="flex justify-center gap-4 mt-4 bg-white p-2">
                              {Object.values(ProductDetailsData?.product?.images)
                                .filter((image) => image)
                                .slice(0, 3)
                                .map((image, index) => (
                                  <img
                                    loading="lazy"
                                    key={index}
                                    src={image}
                                    alt={`Product image ${index + 1}`}
                                    className="w-[100px] h-[100px] object-cover rounded-md border-2 border-gray-300 hover:scale-110 transition-transform cursor-pointer"
                                    onClick={() => setImages(image)}
                                  />
                                ))}
                            </div>
                          )}
                          <div
                            className="bottom-0 sm:bottom-4 flex gap-5 justify-center mt-10 fixed
                              left-0 right-0 bg-blue-50 p-4 shadow-lg  sm:relative sm:mb-0 sm:bg-transparent sm:shadow-none
                          sm:flex-row sm:justify-center sm:gap-5 sm:p-0 sm:mt-10 sm:z-0 z-10 "
                          >
                            {ProductDetailsData?.product?.outOfStock ? <span className="bg-red-500 border text-white text-lg font-semibold px-3 py-2 rounded-xl shadow-md  transition duration-300 flex items-center gap-3">
                              <span>Out of stock</span>
                            </span> :
                              <button
                                onClick={() => setModalQuantity(true)}
                                className="bg-white border text-black text-lg font-semibold px-3 py-2 rounded-xl shadow-md hover:text-white hover:bg-blue-600 transition duration-300 flex items-center gap-3"
                              >
                                <FaShoppingCart size={20} />
                                <span>{isInCart ? "Added to Cart" : "Add to Cart"}</span>
                              </button>
                            }
                            {ProductDetailsData?.product?.outOfStock ? "" :
                              <button
                                onClick={() => {
                                  if (isInCart) {
                                    setLoader(true)
                                    navigate("/cart");
                                    setLoader(false)
                                  }
                                  else {
                                    handleAddToCartBuy();
                                  }
                                }}
                                className="bg-orange-400 text-white text-lg font-semibold py-3 px-6 rounded-xl shadow-md hover:bg-green-600 transition duration-300 flex items-center gap-3"
                              >
                                <FaCreditCard size={20} />
                                <span>Buy Now</span>
                              </button>
                            }
                          </div>
                        </div>
                      </div>

                      <div className="w-full md:w-1/2 flex flex-col  px-4 sm:px-6 md:px-8 ">
                        <h1 className="text-xl sm:mt-0 mt-12 sm:text-2xl md:text-2xl font-bold">
                          {ProductDetailsData?.product?.title}
                        </h1>
                        {ProductDetailsData?.product?.bulkPricing && ProductDetailsData?.product?.bulkPricing.length > 0 && (
                          <>
                            <h2 className="text-xl font-bold text-gray-800 mb-4 mt-5">Bulk Buying</h2>
                            <div className="flex flex-wrap gap-4">
                              {ProductDetailsData?.product?.bulkPricing?.map((item, index) => {
                                const start = index === 0 ? 1 : ProductDetailsData?.product?.bulkPricing[index - 1]?.minQuantity + 1;
                                const end = item?.minQuantity;
                                const isSelected = selectedBulkIndex?.start === start && selectedBulkIndex?.end === end;

                                return (
                                  <div
                                    key={item._id || index}
                                    onClick={() => setSelectedBulkIndex({ start, end, salePrice: item.salePrice })}
                                    className={`cursor-pointer rounded-lg w-[40%] sm:w-[30%] p-4 border transition-all text-center
              ${isSelected ? 'border-blue-500 bg-blue-50 shadow-lg' : 'border-gray-300 hover:border-blue-400 hover:shadow-md'}
            `}
                                  >
                                    <p className="text-gray-700 font-semibold">
                                      {/* {index === 0 ? `1 - ${end} pieces` : `${start} - ${end} pieces`} */}
                                      {index === 0 ? '' : `${start} - `} {end}  pieces
                                    </p>
                                    <p className="font-bold text-green-600 mt-1">
                                      ₹{item.salePrice} <span className="font-bold text-gray-500">per pieces</span>
                                    </p>
                                    {isSelected && (
                                      <p className="text-sm text-blue-500 mt-1 font-medium">Selected</p>
                                    )}
                                  </div>
                                );
                              })}
                            </div>
                          </>
                        )}
                        <div className="flex items-center mt-3">
                          <span className="text-red-600 text-3xl font-bold">
                            ₹{ProductDetailsData?.product?.salePrice}
                          </span>
                          <span className="line-through text-gray-500 text-lg ml-2">
                            ₹{ProductDetailsData?.product?.regularPrice}
                          </span>
                          {ProductDetailsData?.product?.isCodeAvailable &&
                            <>
                              <div className="text-xl flex items-center gap-2 ms-2">
                                <span className=" bg-gradient-to-r from-red-500 to-red-500 text-white text-xs font-bold px-2 py-1 rounded-br-xl shadow animate-pulse">
                                  Cod Available
                                </span>
                              </div>
                            </>
                          }
                        </div>

                        <div className="text-xl mt-2 flex items-center gap-2">
                          <span className="font-bold">Category:</span>
                          <div
                            onClick={() => _handleClick(ProductDetailsData?.product)}
                            className="text-orange-600 hover:text-orange-800 hover:underline flex items-center gap-1"
                          >
                            {ProductDetailsData?.product?.category}
                            <FaArrowCircleRight className="text-orange-400" />
                          </div>
                        </div>
                        <div className="text-xl mt-2">
                          <span className="font-bold">Subcategory: </span>
                          <span className="text-gray-700">
                            {ProductDetailsData?.product?.subcategory}
                          </span>
                        </div>

                        {ProductDetailsData?.product?.reviewList?.length > 0 && (
                          <>
                            <div className="flex items-center mt-2">
                              <span className="font-bold mr-2">Rating:</span>
                              <div className="flex items-center">
                                {[...Array(5)].map((_, index) => {
                                  const starValue = index + 1;
                                  return starValue <= ProductDetailsData?.product?.reviewList[0]?.rating ? (
                                    <FaStar key={index} size={20} color="gold" />
                                  ) : (
                                    <FaRegStar key={index} size={20} color="gold" />
                                  );
                                })}
                                <span className="ml-2 text-gray-700">
                                  ({ProductDetailsData?.product?.reviewList[0]?.rating})
                                </span>
                              </div>
                            </div>
                            <div className="text-m text-black"> <span className="font-bold"> Visitors :</span>
                              {ProductDetailsData?.product?.reviewList[0]?.orderCount
                                ? ` ${ProductDetailsData?.product?.reviewList[0]?.viewCount}`
                                : null}
                            </div>
                            <div className="text-m text-black"> <span className="font-bold"> Order Count :</span>
                              {ProductDetailsData?.product?.reviewList[0]?.orderCount
                                ? ` ${ProductDetailsData?.product?.reviewList[0]?.orderCount}`
                                : null}
                            </div>
                          </>
                        )}

                        {(() => {
                          const rawGiftData = ProductDetailsData?.product?.associatedFreeProducts;

                          const freeGifts = Array.isArray(rawGiftData)
                            ? rawGiftData
                            : rawGiftData
                              ? [rawGiftData]
                              : [];

                          if (freeGifts.length === 0) return null;

                          return (
                            <div className="w-full sm:w-[90%] md:w-[80%] lg:w-[100%] mx-auto mb-6 mt-6">
                              <div className="flex flex-wrap gap-4 justify-center">
                                {freeGifts.map((gift, index) => {
                                  const length = freeGifts.length;
                                  let widthClass = "w-full";
                                  if (length === 2) widthClass = "sm:w-[48%]";
                                  else if (length === 3) widthClass = "sm:w-[31%]";

                                  const isSingle = length === 1;

                                  return (
                                    <div
                                      key={index}
                                      className={`bg-white border border-gray-300 rounded-xl shadow-md p-4 flex ${isSingle ? "flex-row" : "flex-col"
                                        } items-center sm:items-start ${widthClass}`}
                                    >
                                      <div className={`relative ${isSingle ? "w-[40%]" : "w-full"}`}>
                                        <span className="absolute top-0 left-0 bg-gradient-to-r from-pink-500 to-red-500 text-white text-xs font-bold px-2 py-1 rounded-br-xl shadow animate-pulse">
                                          🎁 Free Gift!
                                        </span>
                                        <img
                                          src={gift?.image}
                                          alt="Free Gift"
                                          className={`${isSingle
                                            ? "h-[120px] sm:h-[140px] w-full object-contain"
                                            : "w-full h-[120px] sm:h-[140px] object-contain"
                                            } transition-transform duration-300 `}
                                        />
                                      </div>

                                      <div className={`${isSingle ? "w-[60%] pl-4" : "w-full mt-2"}`}>
                                        <h2 className="text-lg sm:text-xl font-semibold text-gray-800 line-clamp-1">
                                          {gift?.title}
                                        </h2>
                                        <p className="text-sm text-black mt-1 line-clamp-3 w-[95%]">
                                          {gift?.description}
                                        </p>
                                        <div className="mt-2">
                                          <span className="text-green-600 font-bold text-lg">
                                            ₹{gift?.price}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          );
                        })()}

                        {ProductDetailsData?.product?.specifications && (
                          <div className="mt-4">
                            <h3 className="font-semibold text-2xl mb-2">
                              Specifications:
                            </h3>
                            <table className="w-full border rounded-md">
                              <thead className="bg-gray-200">
                                <tr>
                                  <th className="px-4 py-2 text-left">
                                    Specification
                                  </th>
                                  <th className="px-4 py-2 text-left">Value</th>
                                </tr>
                              </thead>
                              <tbody>
                                {ProductDetailsData?.product?.specifications
                                  .filter(
                                    (spec) =>
                                      spec.key.trim() !== "" && spec.values.length > 0
                                  )
                                  .map((spec) => (
                                    <tr key={spec.key} className="border-t">
                                      <td className="px-4 py-2">{spec.key}</td>
                                      <td className="px-4 py-2">{spec.values}</td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          </div>
                        )}

                        <div className="md:flex md:flex-nowrap mt-4 justify-center">

                          <img
                            src={image1}
                            alt="Image 1"
                            className="w-[300px] h-[200px] md:w-[350px] md:h-[250px]"
                          />
                        </div>

                        <div className="flex items-center justify-between mb-2 mt-3">
                          <h2 className="font-bold text-lg sm:text-2xl">
                            Description
                          </h2>
                          {descriptionPoints?.length > 0 && (
                            <button
                              onClick={openModal}
                              className="text-sm text-blue-600 hover:underline"
                            >
                              Read Full
                            </button>
                          )}
                        </div>

                        <li>
                          {ProductDetailsData?.product?.description?.slice(0, 400)}
                        </li>

                        {ProductDetailsData?.product?.stock != 0 && (
                          <div className="mt-5 border-b pb-4">
                            <h3 className="font-bold text-lg sm:text-2xl mb-2">
                              Stock Availability:
                            </h3>
                            <p className="text-lg">
                              {ProductDetailsData?.product?.stock} in stock
                            </p>
                          </div>
                        )}

                        <div className="flex justify-between pt-2 mt-2">
                          <h3 className=" font-bold text-lg sm:text-2xl">Rating & Review</h3>
                          <button
                            onClick={() => _handleReview(item)}
                            className=" bg-orange-500 text-white font-bold
               px-2 sm:px-2 md:px-3
               py-2 sm:py-2 md:py-2
               text-xs sm:text-xs md:text-sm
               rounded-md shadow-md hover:bg-blue-700 transition"
                          >
                            Rate Product
                          </button>
                        </div>

                        {GetReviewData?.reviews && (
                          <div className="w-[100%] text-left mx-auto rounded-lg ">
                            {GetReviewData?.reviews?.map((review) => {
                              return (
                                <div key={review.id} className=" py-1 border-gray-300">
                                  <div className=" items-center justify-between">
                                    <h3 className="text-lg font-semibold">
                                      {review?.user?.name}
                                    </h3>
                                  </div>
                                  <p className="text-gray-700 line-clamp-3 ">
                                    {review.comment}
                                  </p>
                                  <div className="flex text-yellow-500 justify-between mt-2">
                                    <div className="flex flex-row">
                                      {[...Array(5)].map((_, i) =>
                                        i < review.rating ? (
                                          <FaStar key={i} />
                                        ) : (
                                          <FaRegStar key={i} />
                                        )
                                      )}
                                    </div>
                                    <span className="text-gray-700 text-sm me-5">
                                      {/* {format(new Date(review?.createdAt), "yyyy-MM-dd")} */}
                                    </span>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        )}
                        {GetReviewData?.reviews?.length > 5 && (
                          <button
                            onClick={() => setShowAll(!showAll)}
                            className="mt-3 text-blue-600 font-semibold underline"
                          >
                            {showAll ? "Show Less" : "View All Reviews"}
                          </button>
                        )}
                      </div>
                    </div>

                    {subCategory?.length > 0 && (
                      <div className="w-[90%] mt-10 mx-auto border">
                        <div className="rounded-md px-4 py-5 w-[90%]">
                          <h1 className="text-black font-bold text-xl text-center mb-4">
                            Explore Similar Products
                          </h1>

                          <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-8 gap-4 justify-items-center">
                            {visibleItems.map((item, index) => (
                              <div
                                onClick={() => {
                                  _handleSubCategoryClick(item);
                                }}
                                key={index}
                                className="bg-white rounded-xl py-3 px-2 flex flex-col items-center justify-center cursor-pointer
                           transition-transform hover:scale-105"
                              >
                                <img
                                  loading="lazy"
                                  src={
                                    item?.productimage1 ||
                                    item?.images?.productimage1 ||
                                    item.image
                                  }
                                  alt={item.name}
                                  className="w-12 h-12 object-cover rounded-lg mb-2"
                                />
                                <p
                                  className="text-sm font-medium text-center text-black w-full line-clamp-2"
                                  title={item.name}
                                >
                                  {item.name}
                                </p>
                              </div>
                            ))}
                          </div>

                          {!showAll && subCategory.length > 6 && (
                            <div className="flex justify-center mt-4">
                              <button
                                onClick={() => setShowAll(true)}
                                className="bg-gray-200 hover:bg-gray-300 text-black text-sm font-medium py-1 px-4 rounded-full"
                              >
                                View All
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                    {RelatedProductData?.data && (
                      <div
                        onClick={() => setImages("")}
                        className={`${CustomeStyle.container} z-0 sm:mt-10 mt-5 mb-5 px-4 sm:px-6 md:px-8`}
                      >
                        <h1 className={CustomeStyle.headerText}>
                          You can also purchase
                        </h1>
                        <AllProduct product={RelatedProductData?.data} />
                      </div>
                    )}

                    {showModal && (
                      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                        <div className="bg-white p-10 rounded-lg shadow-lg w-[80%]">
                          <h2 className="text-lg font-semibold mb-3">
                            Rate Your Experience
                          </h2>

                          <div className="flex gap-1 mb-3">
                            {[...Array(5)].map((_, index) => {
                              const starValue = index + 1;
                              return (
                                <FaStar
                                  key={index}
                                  size={24}
                                  className={`cursor-pointer ${starValue <= (hover || rating)
                                    ? "text-yellow-400"
                                    : "text-gray-300"
                                    }`}
                                  onMouseEnter={() => setHover(starValue)}
                                  onMouseLeave={() => setHover(null)}
                                  onClick={() => setRating(starValue)}
                                />
                              );
                            })}
                          </div>
                          <input
                            type="text"
                            placeholder="Enter your name"
                            className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400 mb-3"
                            value={userName}
                            onChange={(e) => setUserName(e.target.value)}
                            required
                          />

                          <input
                            type="text"
                            placeholder="Enter your email"
                            className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400 mb-3"
                            value={userEmail}
                            onChange={(e) => setUserEmail(e.target.value)}
                            required
                          />

                          <textarea
                            rows="3"
                            placeholder="Write your review..."
                            className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
                            value={review}
                            required
                            onChange={(e) => setReview(e.target.value)}
                          ></textarea>

                          <div className="flex justify-end gap-2 mt-4">
                            <button
                              onClick={() => setShowModal(false)}
                              className="px-3 py-1 border rounded-md hover:bg-gray-200"
                            >
                              Cancel
                            </button>
                            <button
                              onClick={handleSubmit}
                              className="bg-blue-600 text-white px-4 py-2 rounded-md shadow-md hover:bg-blue-700 transition"
                              disabled={!userName || !rating || !review}
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                </div>
                {isModalOpen && (
                  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white w-11/12 max-w-lg p-6 rounded-lg shadow-xl max-h-[80vh] overflow-y-auto">
                      <div className="flex justify-between items-center mb-4">
                        <h3 className="text-xl font-bold">Full Description</h3>
                        <button
                          onClick={closeModal}
                          className="text-gray-500 hover:text-black text-sm"
                        >
                          ✕
                        </button>
                      </div>
                      <ul className="list-disc pl-5 space-y-2 text-gray-800 text-sm sm:text-base">
                        {descriptionPoints.map((point, index) => (
                          <li key={index}>{point.trim()}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}
              </div>
            </>
          ) : (
            <div className="flex flex-col items-center justify-center mt-5 px-4">
              <img
                src={require("../assets/NoData.png")}
                alt="Product Not Found"
                className="
      w-full max-w-[400px] 
      h-auto 
      object-contain 
      bg-red-100 
      sm:max-w-[300px] 
      md:max-w-[350px] 
      lg:max-w-[400px]
    "
              />

              <button
                onClick={() => navigate("/")}
                className="
      mt-5 bg-blue-500 text-white 
      px-4 py-2 rounded-md 
      hover:bg-blue-600 
      transition 
      w-full max-w-[200px]
    "
              >
                Go to Home
              </button>
            </div>

          )}
        </div>
      </div>

      {
        showModalQuantity && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-xl p-6 w-80 shadow-lg text-center">
              <h2 className="text-xl font-semibold mb-4">Select Quantity</h2>

              <div className="flex items-center justify-center gap-4 mb-6">
                <button
                  onClick={() => setQuantity(prev => Math.max(1, prev - 1))}
                  className="w-10 h-10 rounded-full bg-gray-200 text-xl font-bold hover:bg-gray-300"
                >
                  -
                </button>
                <input
                  type="number"
                  value={quantity}
                  onChange={(e) => setQuantity(Number(e.target.value))}
                  className="w-16 text-center border rounded-lg text-lg"
                  min="1"
                />
                <button
                  onClick={() => setQuantity(prev => prev + 1)}
                  className="w-10 h-10 rounded-full bg-gray-200 text-xl font-bold hover:bg-gray-300"
                >
                  +
                </button>
              </div>

              <div className="flex justify-between gap-3">
                <button
                  onClick={() => setModalQuantity(false)}
                  className="flex-1 py-2 bg-gray-300 rounded-lg font-semibold hover:bg-gray-400"
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    handleAddToCart(quantity);
                    setShowModal(false);
                  }}
                  className="flex-1 py-2 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700"
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        )
      }

      <div className="sm:mt-20 mt-5 flex:1 bottom-0 w-full">
        <Footer />
      </div>
      {loader && <LoaderPage />}
    </div >
  );
};

export default ProductDetails;
